import { DatasourcedWidgetMetadata } from '@/modules/ta/widget/models/metadata/DataSourcedWidgetMetadata';

export class ChatGPTWidgetMetadata extends DatasourcedWidgetMetadata {
  constructor(model = {}) {
    super(model);
  }
}
